module.exports = __webpack_public_path__ + "static/media/icon-done-on.1d7d7be4.svg";